module.exports = __webpack_public_path__ + "static/media/DiffQuery.d27be142.png";